import styled from 'styled-components'
import { MEDIA } from 'src/utils'

const { DESKTOP_UP } = MEDIA

export const ModalBox = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: ${props => props.visible ? 1073 : -100};
  display: flex;
  flex-direction: column;
  overflow: auto;
  width: 100vw;
  max-height: 100vh;
  background-color: var(--the-white);
  transition: all 0.05s ease-in;
  opacity: ${props => props.visible ? 1 : 0};
  border-radius: 2.4rem 2.4rem 0 0;
  padding: 16px;
  font-family: var(--primary-font);
  color: var(--gray-5);
  text-align: center;
  align-items: center;
  gap: 16px;
  ${props => props.modalHeight ? `height:${props.modalHeight};` : 'fit-content'}
  @media screen and ${DESKTOP_UP}{
    max-height: 686px;
  }
`

export const ModalBody = styled.section`
  width: 100%;
  max-width: 382px;
  display: flex;
  align-items: center;
  flex-direction: column;
  border-radius: 5px 5px 0 0;
  gap: 24px;
`

export const ModalTitle = styled.h1`
  font-family: var(--primary-font);
  font-size: 18px;
  font-weight: 600;
  line-height: 19px;
  letter-spacing: 0px;
  text-align: center;
  color: var(--gray-2);
`

export const ModalSubtitle = styled.h2`
  font-family: var(--primary-font);
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0px;
  text-align: ${props => props.decentralizedSubTitle ? 'left' : 'center'};
  color: var(--gray-5);
`

export const ModalContent = styled.section`
  width: 100%;
  hr {
    margin: 24px 0;
    border: none;
    border-top: 1px solid var(--silver);
    color: var(--silver);
  }
`

export const ModalBackdrop = styled.span`
  display: ${props => props.visible ? 'flex' : 'none'};
  align-items:center;
  justify-content:center;
  content: '';
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1072;
`

export const ModalClose = styled.button`
  display: flex;
  align-items: start;
  justify-content: end;
  width: fit-content;
  line-height: 24px;
  border: none;
  background: none;
  cursor: pointer;
  align-self: end;
  margin-bottom: 8px;
`

export const ModalBack = styled.button`
  display: flex;
  align-items: start;
  justify-content: start;
  width: fit-content;
  line-height: 24px;
  border: none;
  background: none;
  cursor: pointer;
  align-self: start;
  margin-bottom: 8px;
`

export const ModalHeaderWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: ${props => props.largeHeaderGap ? '24px' : '8px'};
`
